import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { REGISTRATION, EDIT_REGISTRATION } from "../Constants";
import { RegistrationSuccess, RegistrationFailure, EditRegistrationSuccess, EditRegistrationFailure } from "../Actions/SignupAction";
import { logout } from "../../utils";

function* RegistrationRequest() {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` };
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/registration_url`, { headers: headers });
    if (res.status === 200) {
      yield put(RegistrationSuccess(res.data));
    } else yield put(RegistrationFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(RegistrationFailure(e));
  }
}

function* EditRegistrationRequest(actions) {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` };
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/edit_registration_url`,
      {
        id: actions.payload.id,
        url: actions.payload.url,
      },
      { headers: headers }
    );
    if (res.status === 200) {
      yield put(EditRegistrationSuccess(res.data));
    } else yield put(EditRegistrationFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditRegistrationFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(REGISTRATION, RegistrationRequest);
  yield takeLatest(EDIT_REGISTRATION, EditRegistrationRequest);
}

export default function* RegistrationSaga() {
  yield all([actionWatcher()]);
}
